// TODO: history supported models are currently hardcoded - will need a better way to determine this
const modelsWithHistorySupport = [
  'gemma-3-4b-it',
  'Qwen2_5-Coder-7B-Instruct-vllm',
  'phi-4',
  'MiniCPM3-4B',
  'QwQ-32B-AWQ',
  'phi-4-mini-instruct',
  'Qwen2_5-VL-7B-Instruct',
  'Llama-3_2-3B-Instruct',
];

export const getIsHistorySupported = (modelId: string) => {
  return modelsWithHistorySupport.includes(modelId);
};
